// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team-dashboard {
  padding: 1rem;
  max-width: 1200px;
  margin: 0 auto;
}

.team-dashboard.dark-theme {
  color: #ffffff;
}

/* Состояния загрузки и ошибок */
.no-team-selected,
.loading-state,
.error-state,
.no-data-state {
  text-align: center;
  padding: 60px 20px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  margin: 20px 0;
}

.dark-theme .no-team-selected,
.dark-theme .loading-state,
.dark-theme .error-state,
.dark-theme .no-data-state {
  background: rgba(255, 255, 255, 0.05);
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3bbddb;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.retry-btn {
  background: #3bbddb;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  margin-top: 15px;
}

.retry-btn:hover {
  background: #2a9bb8;
}

/* Заголовок дашборда */
.dashboard-header {
  margin-bottom: 2rem;
  text-align: center;
}

.dashboard-header h2 {
  color: #333;
  margin-bottom: 1rem;
  font-size: 1.8rem;
}

.dark-theme .dashboard-header h2 {
  color: #ffffff;
}

.team-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.team-color-indicator {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  flex-shrink: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.team-details {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  justify-content: center;
}

.team-details p {
  margin: 0;
  font-size: 0.9rem;
  color: #666;
  background: #f8f9fa;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  border: 1px solid #e9ecef;
}

.dark-theme .team-details p {
  color: #a0aec0;
  background: #2d3748;
  border-color: #4a5568;
}

/* Ключевые показатели */
.metrics-summary {
  margin-bottom: 2rem;
}

.metrics-summary h3 {
  font-size: 1.8rem;
  margin-bottom: 1rem;
  color: #333;
  text-align: center;
}

.dark-theme .metrics-summary h3 {
  color: #ffffff;
}

.metrics-grid {
  display: flex;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
}

.metric-card {
  text-align: center;
  padding: 1rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 12px;
  min-width: 120px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.dark-theme .metric-card {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}

.metric-card:hover {
  transform: translateY(-5px);
}

.metric-card h4 {
  margin: 0 0 0.5rem 0;
  font-size: 0.9rem;
  opacity: 0.9;
  font-weight: normal;
}

.metric-value {
  display: block;
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  color: white;
}

.metric-bar {
  width: 100%;
  height: 6px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
  overflow: hidden;
  margin-top: 0.5rem;
}

.metric-fill {
  height: 100%;
  border-radius: 3px;
  transition: width 0.8s ease;
  background: rgba(255, 255, 255, 0.8);
}

/* Секция графиков */
.charts-section {
  margin-bottom: 40px;
}

.charts-section h3,
.charts-section-header h3 {
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
  text-align: center;
}

.charts-section-header {
  text-align: center;
  margin-bottom: 20px;
}

.charts-section-subtitle {
  margin: -12px 0 0;
  color: #64748b;
  font-size: 0.88rem;
}

.dark-theme .charts-section h3 {
  color: #ffffff;
}

.charts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 2rem;
}

.chart-container {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
  overflow: hidden;
}

.dark-theme .chart-container {
  background: #2d3748;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.chart-container:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}

.dark-theme .chart-container:hover {
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4);
}

/* Убираем дублирование луп - подсказка уже есть в компоненте */

/* Модальное окно для графиков */
.chart-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  backdrop-filter: blur(5px);
}

.chart-modal {
  background: white;
  border-radius: 12px;
  max-width: 90vw;
  max-height: 90vh;
  width: 100%;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: modalSlideIn 0.3s ease;
}

.dark-theme .chart-modal {
  background: #2d3748;
  color: white;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.chart-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.dark-theme .chart-modal-header {
  background: #1a202c;
  border-bottom-color: #4a5568;
}

.chart-modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

.chart-modal-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 5px;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
}

.dark-theme .chart-modal-close {
  color: #a0aec0;
}

.chart-modal-close:hover {
  background: #e2e8f0;
  color: #333;
}

.dark-theme .chart-modal-close:hover {
  background: #4a5568;
  color: #ffffff;
}

.chart-modal-content {
  padding: 25px;
  overflow: auto;
  max-height: calc(90vh - 100px);
}



/* Адаптивность */
@media (max-width: 768px) {
  .dashboard-grid {
    grid-template-columns: 1fr;
  }
  
  .stats-summary {
    flex-direction: column;
    align-items: center;
  }
  
  .stat-item {
    min-width: 200px;
  }
  
  .stat-number {
    font-size: 1.5rem;
  }
  
  .bar-label {
    min-width: 80px;
    font-size: 0.8rem;
  }
  
  .method-grid {
    grid-template-columns: 1fr;
  }
  
  .chart-container {
    padding: 1rem;
  }
  
  .chart-modal {
    max-width: 95vw;
    max-height: 95vh;
  }
  
  .chart-modal-content {
    padding: 1rem;
  }
}

/* Секция карточки команды */
.team-card-section {
  margin-bottom: 2rem;
  display: flex;
  justify-content: center;
  min-width: 100%;
}

.team-card-section .team-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
  transition: transform 0.2s, box-shadow 0.2s;
  min-width: 100%;
}

.dark-theme .team-card {
  background: #2d3748;
  border-color: #4a5568;
}

.team-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}

.dark-theme .team-card:hover {
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4);
}

.team-card-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.team-card-header h4 {
  color: #333;
  margin: 0;
  font-size: 1.3rem;
  font-weight: 600;
}

.dark-theme .team-card-header h4 {
  color: #ffffff;
}

.team-stats {
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #f1f3f4;
}

.dark-theme .team-stats {
  border-bottom-color: #4a5568;
}

.team-stats p {
  margin: 0.5rem 0;
  color: #666;
  font-size: 0.9rem;
}

.dark-theme .team-stats p {
  color: #a0aec0;
}

.team-metrics {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.metric {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
}

.metric span:first-child {
  color: #555;
  font-size: 0.9rem;
}

.dark-theme .metric span:first-child {
  color: #a0aec0;
}

.team-card .metric-value {
  font-weight: 600;
  color: #2193b0;
  font-size: 1rem;
}

.dark-theme .team-card .metric-value {
  color: #3bbedb;
}

.team-card-actions {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #f1f3f4;
}

.dark-theme .team-card-actions {
  border-top-color: #4a5568;
}

.detail-view-btn {
  background: linear-gradient(135deg, #667eea 0%, #2193b0 100%);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  width: 100%;
}

.detail-view-btn:hover {
  background: linear-gradient(135deg, #2193b0 0%, #667eea 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

/* Модальное окно детального просмотра */
.detail-view-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  backdrop-filter: blur(5px);
}

.detail-view-content {
  background: white;
  border-radius: 16px;
  max-width: 90vw;
  max-height: 90vh;
  width: 800px;
  overflow: hidden;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  animation: modalSlideIn 0.3s ease;
}

.dark-theme .detail-view-content {
  background: #2d3748;
  color: white;
}

.detail-view-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px;
  border-bottom: 1px solid #e2e8f0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.dark-theme .detail-view-header {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  border-bottom-color: #4a5568;
}

.detail-view-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: white;
  padding: 8px;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.detail-view-body {
  padding: 25px;
  overflow: auto;
  max-height: calc(90vh - 100px);
}

.team-detail-info h4,
.metrics-detail-charts h4 {
  color: #333;
  margin-bottom: 1rem;
  font-size: 1.2rem;
  font-weight: 600;
}

.dark-theme .team-detail-info h4,
.dark-theme .metrics-detail-charts h4 {
  color: #ffffff;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}

.info-item {
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.dark-theme .info-item {
  background: #4a5568;
  border-color: #2d3748;
}

.info-item strong {
  color: #333;
  font-weight: 600;
}

.dark-theme .info-item strong {
  color: #ffffff;
}

.metrics-detail-charts .metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}

.metric-detail-card {
  background: white;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.dark-theme .metric-detail-card {
  background: #4a5568;
}

.metric-detail-card h5 {
  margin: 0 0 1rem 0;
  color: #333;
  font-size: 1rem;
  font-weight: 600;
}

.dark-theme .metric-detail-card h5 {
  color: #ffffff;
}

.metric-progress {
  width: 100%;
  height: 8px;
  background: #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 0.5rem;
}

.dark-theme .metric-progress {
  background: #2d3748;
}

.metric-progress-bar {
  height: 100%;
  border-radius: 4px;
  transition: width 0.8s ease;
}

.metric-detail-card .metric-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #333;
}

.dark-theme .metric-detail-card .metric-value {
  color: #ffffff;
}

/* Навигация в модальном окне */
.detail-view-navigation {
  display: flex;
  gap: 0.5rem;
  padding: 20px 25px 20px 25px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.dark-theme .detail-view-navigation {
  background: #1a202c;
  border-bottom-color: #4a5568;
}

.detail-nav-btn {
  background: white;
  border: 1px solid #dee2e6;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  color: #666;
  transition: all 0.2s ease;
}

.dark-theme .detail-nav-btn {
  background: #2d3748;
  border-color: #4a5568;
  color: #a0aec0;
}

.detail-nav-btn:hover {
  background: #e2e8f0;
  color: #333;
}

.dark-theme .detail-nav-btn:hover {
  background: #4a5568;
  color: #ffffff;
}

.detail-nav-btn.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-color: #667eea;
}

.dark-theme .detail-nav-btn.active {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  border-color: #667eea;
}

/* Секция шагов процесса */
.steps-detail-view h4 {
  color: #333;
  margin-bottom: 1.5rem;
  font-size: 1.2rem;
  font-weight: 600;
}

.dark-theme .steps-detail-view h4 {
  color: #ffffff;
}

.steps-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.step-item {
  display: flex;
  gap: 1rem;
  padding: 1rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.dark-theme .step-item {
  background: #4a5568;
  border-color: #2d3748;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.step-number {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  flex-shrink: 0;
}

.step-content {
  flex: 1 1;
}

.step-category {
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
  font-size: 1rem;
}

.dark-theme .step-category {
  color: #ffffff;
}

.step-product {
  color: #666;
  margin-bottom: 0.25rem;
  font-size: 0.9rem;
}

.dark-theme .step-product {
  color: #a0aec0;
}

.step-action {
  color: #333;
  margin-bottom: 0.25rem;
  font-size: 0.9rem;
}

.dark-theme .step-action {
  color: #ffffff;
}

.step-code {
  color: #2193b0;
  font-family: 'Courier New', monospace;
  font-size: 0.8rem;
  background: #f8f9fa;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  display: inline-block;
}

.dark-theme .step-code {
  color: #3bbedb;
  background: #2d3748;
}

.no-steps {
  text-align: center;
  padding: 2rem;
  color: #666;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.dark-theme .no-steps {
  color: #a0aec0;
  background: #4a5568;
  border-color: #2d3748;
}

/* Секция графиков */
.charts-detail-view h4 {
  color: #333;
  margin-bottom: 1.5rem;
  font-size: 1.2rem;
  font-weight: 600;
}

.dark-theme .charts-detail-view h4 {
  color: #ffffff;
}

.detail-charts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 2rem;
}

.detail-chart-container {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.dark-theme .detail-chart-container {
  background: #4a5568;
  border-color: #2d3748;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.detail-chart-container h5 {
  color: #333;
  margin-bottom: 1rem;
  font-size: 1.1rem;
  font-weight: 600;
  text-align: center;
}

.dark-theme .detail-chart-container h5 {
  color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/TeamDashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,gCAAgC;AAChC;;;;EAIE,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;EAIE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,6DAA6D;EAC7D,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,eAAe;EACf,qDAAqD;EACrD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,+DAA+D;;AAE/D,gCAAgC;AAChC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,8BAA8B;AAChC;;;;AAIA,iBAAiB;AACjB;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,yBAAyB;EACzB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,8BAA8B;AAChC;;AAEA;;EAEE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,WAAW;EACX,4BAA4B;EAC5B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".team-dashboard {\r\n  padding: 1rem;\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.team-dashboard.dark-theme {\r\n  color: #ffffff;\r\n}\r\n\r\n/* Состояния загрузки и ошибок */\r\n.no-team-selected,\r\n.loading-state,\r\n.error-state,\r\n.no-data-state {\r\n  text-align: center;\r\n  padding: 60px 20px;\r\n  background: rgba(255, 255, 255, 0.05);\r\n  border-radius: 12px;\r\n  margin: 20px 0;\r\n}\r\n\r\n.dark-theme .no-team-selected,\r\n.dark-theme .loading-state,\r\n.dark-theme .error-state,\r\n.dark-theme .no-data-state {\r\n  background: rgba(255, 255, 255, 0.05);\r\n}\r\n\r\n.loading-spinner {\r\n  width: 40px;\r\n  height: 40px;\r\n  border: 4px solid #f3f3f3;\r\n  border-top: 4px solid #3bbddb;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n  margin: 0 auto 20px;\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n.retry-btn {\r\n  background: #3bbddb;\r\n  color: white;\r\n  border: none;\r\n  padding: 10px 20px;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  margin-top: 15px;\r\n}\r\n\r\n.retry-btn:hover {\r\n  background: #2a9bb8;\r\n}\r\n\r\n/* Заголовок дашборда */\r\n.dashboard-header {\r\n  margin-bottom: 2rem;\r\n  text-align: center;\r\n}\r\n\r\n.dashboard-header h2 {\r\n  color: #333;\r\n  margin-bottom: 1rem;\r\n  font-size: 1.8rem;\r\n}\r\n\r\n.dark-theme .dashboard-header h2 {\r\n  color: #ffffff;\r\n}\r\n\r\n.team-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\n.team-color-indicator {\r\n  width: 16px;\r\n  height: 16px;\r\n  border-radius: 50%;\r\n  flex-shrink: 0;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.team-details {\r\n  display: flex;\r\n  gap: 2rem;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n}\r\n\r\n.team-details p {\r\n  margin: 0;\r\n  font-size: 0.9rem;\r\n  color: #666;\r\n  background: #f8f9fa;\r\n  padding: 0.5rem 1rem;\r\n  border-radius: 20px;\r\n  border: 1px solid #e9ecef;\r\n}\r\n\r\n.dark-theme .team-details p {\r\n  color: #a0aec0;\r\n  background: #2d3748;\r\n  border-color: #4a5568;\r\n}\r\n\r\n/* Ключевые показатели */\r\n.metrics-summary {\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.metrics-summary h3 {\r\n  font-size: 1.8rem;\r\n  margin-bottom: 1rem;\r\n  color: #333;\r\n  text-align: center;\r\n}\r\n\r\n.dark-theme .metrics-summary h3 {\r\n  color: #ffffff;\r\n}\r\n\r\n.metrics-grid {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 2rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.metric-card {\r\n  text-align: center;\r\n  padding: 1rem;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n  border-radius: 12px;\r\n  min-width: 120px;\r\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.dark-theme .metric-card {\r\n  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);\r\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.metric-card:hover {\r\n  transform: translateY(-5px);\r\n}\r\n\r\n.metric-card h4 {\r\n  margin: 0 0 0.5rem 0;\r\n  font-size: 0.9rem;\r\n  opacity: 0.9;\r\n  font-weight: normal;\r\n}\r\n\r\n.metric-value {\r\n  display: block;\r\n  font-size: 2rem;\r\n  font-weight: bold;\r\n  margin-bottom: 0.5rem;\r\n  color: white;\r\n}\r\n\r\n.metric-bar {\r\n  width: 100%;\r\n  height: 6px;\r\n  background: rgba(255, 255, 255, 0.3);\r\n  border-radius: 3px;\r\n  overflow: hidden;\r\n  margin-top: 0.5rem;\r\n}\r\n\r\n.metric-fill {\r\n  height: 100%;\r\n  border-radius: 3px;\r\n  transition: width 0.8s ease;\r\n  background: rgba(255, 255, 255, 0.8);\r\n}\r\n\r\n/* Секция графиков */\r\n.charts-section {\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.charts-section h3,\r\n.charts-section-header h3 {\r\n  font-size: 24px;\r\n  margin-bottom: 20px;\r\n  color: #333;\r\n  text-align: center;\r\n}\r\n\r\n.charts-section-header {\r\n  text-align: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.charts-section-subtitle {\r\n  margin: -12px 0 0;\r\n  color: #64748b;\r\n  font-size: 0.88rem;\r\n}\r\n\r\n.dark-theme .charts-section h3 {\r\n  color: #ffffff;\r\n}\r\n\r\n.charts-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\r\n  gap: 2rem;\r\n}\r\n\r\n.chart-container {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\r\n  cursor: pointer;\r\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.dark-theme .chart-container {\r\n  background: #2d3748;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.chart-container:hover {\r\n  transform: translateY(-5px);\r\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.dark-theme .chart-container:hover {\r\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4);\r\n}\r\n\r\n/* Убираем дублирование луп - подсказка уже есть в компоненте */\r\n\r\n/* Модальное окно для графиков */\r\n.chart-modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.8);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  padding: 20px;\r\n  backdrop-filter: blur(5px);\r\n}\r\n\r\n.chart-modal {\r\n  background: white;\r\n  border-radius: 12px;\r\n  max-width: 90vw;\r\n  max-height: 90vh;\r\n  width: 100%;\r\n  overflow: hidden;\r\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\r\n  animation: modalSlideIn 0.3s ease;\r\n}\r\n\r\n.dark-theme .chart-modal {\r\n  background: #2d3748;\r\n  color: white;\r\n}\r\n\r\n@keyframes modalSlideIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: scale(0.9) translateY(-20px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: scale(1) translateY(0);\r\n  }\r\n}\r\n\r\n.chart-modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 20px 25px;\r\n  border-bottom: 1px solid #e2e8f0;\r\n  background: #f8fafc;\r\n}\r\n\r\n.dark-theme .chart-modal-header {\r\n  background: #1a202c;\r\n  border-bottom-color: #4a5568;\r\n}\r\n\r\n.chart-modal-header h3 {\r\n  margin: 0;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n}\r\n\r\n.chart-modal-close {\r\n  background: none;\r\n  border: none;\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n  color: #666;\r\n  padding: 5px;\r\n  border-radius: 50%;\r\n  width: 40px;\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.dark-theme .chart-modal-close {\r\n  color: #a0aec0;\r\n}\r\n\r\n.chart-modal-close:hover {\r\n  background: #e2e8f0;\r\n  color: #333;\r\n}\r\n\r\n.dark-theme .chart-modal-close:hover {\r\n  background: #4a5568;\r\n  color: #ffffff;\r\n}\r\n\r\n.chart-modal-content {\r\n  padding: 25px;\r\n  overflow: auto;\r\n  max-height: calc(90vh - 100px);\r\n}\r\n\r\n\r\n\r\n/* Адаптивность */\r\n@media (max-width: 768px) {\r\n  .dashboard-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .stats-summary {\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n  \r\n  .stat-item {\r\n    min-width: 200px;\r\n  }\r\n  \r\n  .stat-number {\r\n    font-size: 1.5rem;\r\n  }\r\n  \r\n  .bar-label {\r\n    min-width: 80px;\r\n    font-size: 0.8rem;\r\n  }\r\n  \r\n  .method-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .chart-container {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .chart-modal {\r\n    max-width: 95vw;\r\n    max-height: 95vh;\r\n  }\r\n  \r\n  .chart-modal-content {\r\n    padding: 1rem;\r\n  }\r\n}\r\n\r\n/* Секция карточки команды */\r\n.team-card-section {\r\n  margin-bottom: 2rem;\r\n  display: flex;\r\n  justify-content: center;\r\n  min-width: 100%;\r\n}\r\n\r\n.team-card-section .team-card {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\r\n  border: 1px solid #e9ecef;\r\n  transition: transform 0.2s, box-shadow 0.2s;\r\n  min-width: 100%;\r\n}\r\n\r\n.dark-theme .team-card {\r\n  background: #2d3748;\r\n  border-color: #4a5568;\r\n}\r\n\r\n.team-card:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.dark-theme .team-card:hover {\r\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4);\r\n}\r\n\r\n.team-card-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.team-card-header h4 {\r\n  color: #333;\r\n  margin: 0;\r\n  font-size: 1.3rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.dark-theme .team-card-header h4 {\r\n  color: #ffffff;\r\n}\r\n\r\n.team-stats {\r\n  margin-bottom: 1rem;\r\n  padding-bottom: 1rem;\r\n  border-bottom: 1px solid #f1f3f4;\r\n}\r\n\r\n.dark-theme .team-stats {\r\n  border-bottom-color: #4a5568;\r\n}\r\n\r\n.team-stats p {\r\n  margin: 0.5rem 0;\r\n  color: #666;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.dark-theme .team-stats p {\r\n  color: #a0aec0;\r\n}\r\n\r\n.team-metrics {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.metric {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 0.5rem 0;\r\n}\r\n\r\n.metric span:first-child {\r\n  color: #555;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.dark-theme .metric span:first-child {\r\n  color: #a0aec0;\r\n}\r\n\r\n.team-card .metric-value {\r\n  font-weight: 600;\r\n  color: #2193b0;\r\n  font-size: 1rem;\r\n}\r\n\r\n.dark-theme .team-card .metric-value {\r\n  color: #3bbedb;\r\n}\r\n\r\n.team-card-actions {\r\n  margin-top: 1rem;\r\n  padding-top: 1rem;\r\n  border-top: 1px solid #f1f3f4;\r\n}\r\n\r\n.dark-theme .team-card-actions {\r\n  border-top-color: #4a5568;\r\n}\r\n\r\n.detail-view-btn {\r\n  background: linear-gradient(135deg, #667eea 0%, #2193b0 100%);\r\n  color: white;\r\n  border: none;\r\n  padding: 0.75rem 1.5rem;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  width: 100%;\r\n}\r\n\r\n.detail-view-btn:hover {\r\n  background: linear-gradient(135deg, #2193b0 0%, #667eea 100%);\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\r\n}\r\n\r\n/* Модальное окно детального просмотра */\r\n.detail-view-modal {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.7);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  padding: 20px;\r\n  backdrop-filter: blur(5px);\r\n}\r\n\r\n.detail-view-content {\r\n  background: white;\r\n  border-radius: 16px;\r\n  max-width: 90vw;\r\n  max-height: 90vh;\r\n  width: 800px;\r\n  overflow: hidden;\r\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);\r\n  animation: modalSlideIn 0.3s ease;\r\n}\r\n\r\n.dark-theme .detail-view-content {\r\n  background: #2d3748;\r\n  color: white;\r\n}\r\n\r\n.detail-view-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 20px 25px;\r\n  border-bottom: 1px solid #e2e8f0;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n}\r\n\r\n.dark-theme .detail-view-header {\r\n  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);\r\n  border-bottom-color: #4a5568;\r\n}\r\n\r\n.detail-view-header h3 {\r\n  margin: 0;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n}\r\n\r\n.close-btn {\r\n  background: none;\r\n  border: none;\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n  color: white;\r\n  padding: 8px;\r\n  border-radius: 50%;\r\n  width: 40px;\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.close-btn:hover {\r\n  background: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.detail-view-body {\r\n  padding: 25px;\r\n  overflow: auto;\r\n  max-height: calc(90vh - 100px);\r\n}\r\n\r\n.team-detail-info h4,\r\n.metrics-detail-charts h4 {\r\n  color: #333;\r\n  margin-bottom: 1rem;\r\n  font-size: 1.2rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.dark-theme .team-detail-info h4,\r\n.dark-theme .metrics-detail-charts h4 {\r\n  color: #ffffff;\r\n}\r\n\r\n.info-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\r\n  gap: 1rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.info-item {\r\n  padding: 1rem;\r\n  background: #f8f9fa;\r\n  border-radius: 8px;\r\n  border: 1px solid #e9ecef;\r\n}\r\n\r\n.dark-theme .info-item {\r\n  background: #4a5568;\r\n  border-color: #2d3748;\r\n}\r\n\r\n.info-item strong {\r\n  color: #333;\r\n  font-weight: 600;\r\n}\r\n\r\n.dark-theme .info-item strong {\r\n  color: #ffffff;\r\n}\r\n\r\n.metrics-detail-charts .metrics-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\r\n  gap: 1rem;\r\n}\r\n\r\n.metric-detail-card {\r\n  background: white;\r\n  padding: 1.5rem;\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\r\n  text-align: center;\r\n}\r\n\r\n.dark-theme .metric-detail-card {\r\n  background: #4a5568;\r\n}\r\n\r\n.metric-detail-card h5 {\r\n  margin: 0 0 1rem 0;\r\n  color: #333;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.dark-theme .metric-detail-card h5 {\r\n  color: #ffffff;\r\n}\r\n\r\n.metric-progress {\r\n  width: 100%;\r\n  height: 8px;\r\n  background: #f0f0f0;\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.dark-theme .metric-progress {\r\n  background: #2d3748;\r\n}\r\n\r\n.metric-progress-bar {\r\n  height: 100%;\r\n  border-radius: 4px;\r\n  transition: width 0.8s ease;\r\n}\r\n\r\n.metric-detail-card .metric-value {\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  color: #333;\r\n}\r\n\r\n.dark-theme .metric-detail-card .metric-value {\r\n  color: #ffffff;\r\n}\r\n\r\n/* Навигация в модальном окне */\r\n.detail-view-navigation {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  padding: 20px 25px 20px 25px;\r\n  border-bottom: 1px solid #e2e8f0;\r\n  background: #f8fafc;\r\n}\r\n\r\n.dark-theme .detail-view-navigation {\r\n  background: #1a202c;\r\n  border-bottom-color: #4a5568;\r\n}\r\n\r\n.detail-nav-btn {\r\n  background: white;\r\n  border: 1px solid #dee2e6;\r\n  padding: 0.75rem 1.5rem;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  font-weight: 500;\r\n  color: #666;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.dark-theme .detail-nav-btn {\r\n  background: #2d3748;\r\n  border-color: #4a5568;\r\n  color: #a0aec0;\r\n}\r\n\r\n.detail-nav-btn:hover {\r\n  background: #e2e8f0;\r\n  color: #333;\r\n}\r\n\r\n.dark-theme .detail-nav-btn:hover {\r\n  background: #4a5568;\r\n  color: #ffffff;\r\n}\r\n\r\n.detail-nav-btn.active {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n  border-color: #667eea;\r\n}\r\n\r\n.dark-theme .detail-nav-btn.active {\r\n  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);\r\n  border-color: #667eea;\r\n}\r\n\r\n/* Секция шагов процесса */\r\n.steps-detail-view h4 {\r\n  color: #333;\r\n  margin-bottom: 1.5rem;\r\n  font-size: 1.2rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.dark-theme .steps-detail-view h4 {\r\n  color: #ffffff;\r\n}\r\n\r\n.steps-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n\r\n.step-item {\r\n  display: flex;\r\n  gap: 1rem;\r\n  padding: 1rem;\r\n  background: white;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  border: 1px solid #e9ecef;\r\n}\r\n\r\n.dark-theme .step-item {\r\n  background: #4a5568;\r\n  border-color: #2d3748;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.step-number {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-weight: bold;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.step-content {\r\n  flex: 1;\r\n}\r\n\r\n.step-category {\r\n  font-weight: 600;\r\n  color: #333;\r\n  margin-bottom: 0.5rem;\r\n  font-size: 1rem;\r\n}\r\n\r\n.dark-theme .step-category {\r\n  color: #ffffff;\r\n}\r\n\r\n.step-product {\r\n  color: #666;\r\n  margin-bottom: 0.25rem;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.dark-theme .step-product {\r\n  color: #a0aec0;\r\n}\r\n\r\n.step-action {\r\n  color: #333;\r\n  margin-bottom: 0.25rem;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.dark-theme .step-action {\r\n  color: #ffffff;\r\n}\r\n\r\n.step-code {\r\n  color: #2193b0;\r\n  font-family: 'Courier New', monospace;\r\n  font-size: 0.8rem;\r\n  background: #f8f9fa;\r\n  padding: 0.25rem 0.5rem;\r\n  border-radius: 4px;\r\n  display: inline-block;\r\n}\r\n\r\n.dark-theme .step-code {\r\n  color: #3bbedb;\r\n  background: #2d3748;\r\n}\r\n\r\n.no-steps {\r\n  text-align: center;\r\n  padding: 2rem;\r\n  color: #666;\r\n  background: #f8f9fa;\r\n  border-radius: 8px;\r\n  border: 1px solid #e9ecef;\r\n}\r\n\r\n.dark-theme .no-steps {\r\n  color: #a0aec0;\r\n  background: #4a5568;\r\n  border-color: #2d3748;\r\n}\r\n\r\n/* Секция графиков */\r\n.charts-detail-view h4 {\r\n  color: #333;\r\n  margin-bottom: 1.5rem;\r\n  font-size: 1.2rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.dark-theme .charts-detail-view h4 {\r\n  color: #ffffff;\r\n}\r\n\r\n.detail-charts-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\r\n  gap: 2rem;\r\n}\r\n\r\n.detail-chart-container {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\r\n  border: 1px solid #e9ecef;\r\n}\r\n\r\n.dark-theme .detail-chart-container {\r\n  background: #4a5568;\r\n  border-color: #2d3748;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.detail-chart-container h5 {\r\n  color: #333;\r\n  margin-bottom: 1rem;\r\n  font-size: 1.1rem;\r\n  font-weight: 600;\r\n  text-align: center;\r\n}\r\n\r\n.dark-theme .detail-chart-container h5 {\r\n  color: #ffffff;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
